import React from 'react'

import { v4 as uuid } from 'uuid'

import LocalGasStationIcon from '@mui/icons-material/LocalGasStation'
import MedicationIcon from '@mui/icons-material/Medication'
import BrunchDiningIcon from '@mui/icons-material/BrunchDining'
import FastfoodIcon from '@mui/icons-material/Fastfood'
import MedicalServicesIcon from '@mui/icons-material/MedicalServices'
import GavelIcon from '@mui/icons-material/Gavel'
import CheckroomIcon from '@mui/icons-material/Checkroom'
import FitnessCenterIcon from '@mui/icons-material/FitnessCenter'
import ImportantDevicesIcon from '@mui/icons-material/ImportantDevices'
import FaceRetouchingNaturalIcon from '@mui/icons-material/FaceRetouchingNatural'
import HealthAndSafetyIcon from '@mui/icons-material/HealthAndSafety'
import AssuredWorkloadIcon from '@mui/icons-material/AssuredWorkload'
import TranslateIcon from '@mui/icons-material/Translate'
import PetsIcon from '@mui/icons-material/Pets'
import SchoolIcon from '@mui/icons-material/School'
import CelebrationIcon from '@mui/icons-material/Celebration'
import DirectionsBoatIcon from '@mui/icons-material/DirectionsBoat'
import CarRepairIcon from '@mui/icons-material/CarRepair'
import HandymanIcon from '@mui/icons-material/Handyman'

export const categories = [
  {
    id: 0,
    name: 'OFICINA NÁUTICA',
    icon: <HandymanIcon />
  },
  {
    id: 1,
    name: 'ESTÉTICA NÁUTICA',
    icon: <DirectionsBoatIcon />
  },
  {
    id: 2,
    name: 'POSTOS DE COMBUSTÍVEL',
    icon: <LocalGasStationIcon />
  },
  {
    id: 3,
    name: 'SAÚDE & BELEZA',
    icon: <FaceRetouchingNaturalIcon />
  },
  {
    id: 4,
    name: 'FARMÁCIA & MEDICAMENTOS',
    icon: <MedicationIcon />
  },
  {
    id: 5,
    name: 'GEOMETRIA E BALANCEAMENTO',
    icon: <CarRepairIcon />
  },
  {
    id: 6,
    name: 'BAR & RESTAURANTES',
    icon: <BrunchDiningIcon />
  },
  {
    id: 7,
    name: 'CONVENIÊNCIA',
    icon: <FastfoodIcon />
  },
  {
    id: 8,
    name: 'SEGUROS',
    icon: <HealthAndSafetyIcon />
  },
  {
    id: 9,
    name: 'CONSULTAS MÉDICAS',
    icon: <MedicalServicesIcon />
  },
  {
    id: 10,
    name: 'ODONTOLOGIA',
    icon: <MedicalServicesIcon />
  },
  {
    id: 11,
    name: 'NUTRICIONISTA',
    icon: <MedicalServicesIcon />
  },
  {
    id: 12,
    name: 'ADVOGADOS',
    icon: <GavelIcon />
  },
  {
    id: 13,
    name: 'ROUPAS E ACESSÓRIOS',
    icon: <CheckroomIcon />
  },
  {
    id: 14,
    name: 'ACADEMIAS',
    icon: <FitnessCenterIcon />
  },
  {
    id: 15,
    name: 'E-COMMERCE',
    icon: <ImportantDevicesIcon />
  },
  {
    id: 16,
    name: 'CONTABILIDADE',
    icon: <AssuredWorkloadIcon />
  },
  {
    id: 17,
    name: 'IDIOMAS',
    icon: <TranslateIcon />
  },
  {
    id: 18,
    name: 'PET-SHOP',
    icon: <PetsIcon />
  },
  {
    id: 19,
    name: 'CURSOS',
    icon: <SchoolIcon />
  },
  {
    id: 20,
    name: 'FESTAS E EVENTOS',
    icon: <CelebrationIcon />
  }
]

export const getRandomValue = (min: number, max: number) =>
  Math.floor(Math.random() * (max - min + 1)) + min

const generateCity = () => {
  const options = [
    'Porto Alegre - RS',
    'Canoas - RS',
    'Blumenau - SC',
    'Curitiba - PR',
    'São Paulo - SP',
    'Rio de Janeiro - RJ',
    'Belo Horizonte - MG',
    'Brasília - DF',
    'Salvador - BA',
    'Recife - PE',
    'Fortaleza - CE',
    'Manaus - AM',
    'Belém - PA',
    'Goiânia - GO',
    'São Luís - MA',
    'Maceió - AL',
    'Campo Grande - MS',
    'Cuiabá - MT',
    'Porto Velho - RO',
    'Boa Vista - RR',
    'Palmas - TO',
    'Natal - RN',
    'Teresina - PI',
    'João Pessoa - PB',
    'Aracaju - SE',
    'Vitória - ES',
    'Florianópolis - SC'
  ]
  return options[Math.floor(Math.random() * options.length)]
}

const generateDiscountType = () => {
  const options = [
    'GRÁTIS',
    `${getRandomValue(10, 50)}% OFF`,
    `PAGUE 1 LEVE 2 por R$ ${getRandomValue(10, 20)},00`,
    `PAGUE R$ ${getRandomValue(10, 20)},00`
  ]
  return options[Math.floor(Math.random() * options.length)]
}

const generateEstablishmentType = () => {
  const options = [
    'POSTO',
    `FARMÁCIA`,
    `MERCADO`,
    `PADARIA`,
    'CONSULTÓRIO',
    'ACADEMIA',
    'PET SHOP',
    'LOJA',
    'RESTAURANTE',
    'BAR',
    'ESCOLA',
    'CURSO',
    'CLÍNICA',
    'CONSULTÓRIO',
    'PET SHOP',
    'LOJA',
    'RESTAURANTE',
    'BAR',
    'ESCOLA',
    'CURSO',
    'CLÍNICA'
  ]
  return options[Math.floor(Math.random() * options.length)]
}

const generateEstablishmentName = () => {
  const options = [
    ' DO JOÃO',
    ` DOIS IRMÃOS`,
    ` DA MARIA`,
    ` DO JOSÉ`,
    ' DO CARLOS',
    ' DO LUCAS',
    ' DO MATEUS',
    ' DO PEDRO',
    ' DO GABRIEL',
    ' DO FELIPE',
    ' DO RAFAEL',
    ' DO GUSTAVO',
    ' DO MURILO',
    ' DO RODRIGO',
    ' DO MARCELO',
    ' DO FERNANDO',
    ' DO RICARDO',
    ' DO EDUARDO',
    ' DO GUILHERME',
    ' DO GABRIEL',
    ' DO FELIPE',
    ' DO RAFAEL',
    ' DO GUSTAVO',
    ' DO MURILO',
    ' DO RODRIGO',
    ' DO MARCELO',
    ' DO FERNANDO',
    ' DO RICARDO',
    ' DO EDUARDO',
    ' DO GUILHERME'
  ]
  return options[Math.floor(Math.random() * options.length)]
}

const generateDate = (start: any, end: any) => {
  return new Date(
    start.getTime() + Math.random() * (end.getTime() - start.getTime())
  ).toLocaleDateString()
}

const generateStatus = () => {
  const options = ['DISPONÍVEL', `RESGATADO`, `EXPIRADO`]
  return options[Math.floor(Math.random() * options.length)]
}

const generateValidityAndRewarded = () => {
  const options = [
    generateDate(
      new Date(),
      new Date(new Date().setDate(new Date().getDate() + 30))
    ),
    '-'
  ]
  return options[Math.floor(Math.random() * options.length)]
}

const generateInvoiceType = () => {
  const options = ['FATURA MENSAL', `FATURA AVULSA`]
  return options[Math.floor(Math.random() * options.length)]
}

const generateInvoicePaymentType = () => {
  const options = [
    'PIX',
    `CARTÃO DE CRÉDITO`,
    `BOLETO`,
    `DINHEIRO`,
    `CHEQUE`,
    `TRANSFERÊNCIA BANCÁRIA`
  ]
  return options[Math.floor(Math.random() * options.length)]
}

export const coupons = categories.map(category => ({
  id: uuid(),
  establishment: `${generateEstablishmentType()}${generateEstablishmentName()}`,
  category: category.name,
  discountType: generateDiscountType(),
  city: generateCity(),
  validity: generateValidityAndRewarded(),
  rewarded: generateValidityAndRewarded(),
  status: generateStatus(),
  invoiceDate: generateDate(
    new Date(),
    new Date(new Date().setDate(new Date().getDate() + 30))
  ),
  invoiceType: generateInvoiceType(),
  invoiceValue: `R$ ${getRandomValue(100, 350)},00`,
  invoicePaymentType: generateInvoicePaymentType(),
  couponsGenerated: getRandomValue(1, 5),
  couponsRewarded: getRandomValue(1, 2)
}))
